import(/* webpackMode: "eager" */ "/home/crazysal/sit-a/bd-mobile-next/app/(main)/article/AboutUs/page.tsx");
